import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=77d35204&"
import script from "./userSettings.vue?vue&type=script&lang=js&"
export * from "./userSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports